import React from "react";
import Tilt from "react-parallax-tilt";
import ReactDev from "../images/ReactDev.png";
// import { CiCoffeeCup } from "react-icons/ci";

import { FaReact } from "react-icons/fa";

const About = () => {
  return (
    <>
      <div className="AboutPage" id="about_section">
        <div className="AboutText">
          <h1 className="AboutTextHeading">
            Brief <b>introduction</b>
          </h1>
          <p>
            With <b>3 years of experience</b> in web development, turning ideas into impactful websites and products is my passion. I
            enjoy challenging projects, refining my <b>JavaScript</b> skills,
            and crafting work I'm proud of.
            <br />
            <br />
            Fluent in <b>JavaScript</b>, actively building front-end applications with <b>React</b>, and expanding my expertise in <b>TypeScript</b>. I'm also exploring <b>AI agents</b>, <b>n8n</b> for workflow automation, and <b>Next.js</b>.
            <br />
            <br />
            And, of course, I have a deep love for <b>React</b>{" "}
            <FaReact style={{ scale: "1.2", marginLeft: ".5rem" }} />.
          </p>
        </div>
        <Tilt>
          <img
            className="Avatar"
            style={{ marginTop: "3rem", width: "325px" }}
            src={ReactDev}
            alt="developer"
          />
        </Tilt>
      </div>
    </>
  );
};

export default About;
